export const general = {
  filterDate: {
    year: 'Año',
    month: 'Mes',
  },
  seeReport2: 'Ver informe',
  minCharacters: 'El campo debe contener mínimo {{count}} caracteres',
  pdfActivities: 'Actividades de PDF',
  wordActivities: 'Actividades de Word',
  externalUsers: 'Usuarios externos',
  internalUsers: 'Usuarios internos',
  csvActivities: 'Actividades de Excel',
  informDetail: 'Informe resumen',
  timeZoneDetail: 'Zona horaria: {{timeZone}}',
  service: {
    areaDepartment: {
      main: {
        title: 'Asociación de catálogos para área y departamento',
        table: {
          date: 'Fechas de asignación al departamento',
          area: 'Área',
          department: 'Departamento',
          preventiveCatalog: 'Catálogo preventivo',
          correctiveCatalog: 'Catálogo correctivo',
        },
        action: {
          title: '¿Está seguro que desea eliminar la configuración?',
          description: '',
        },
        snackbar: {
          delete: {
            success: 'La configuración se eliminó exitosamente',
            error: 'Ocurrió un error al eliminar la configuración',
          },
        },
      },
      form: {
        titleCreate: 'Nueva asociación de catálogos para área y departamento',
        titleEdit: 'Editar asociación de catálogos para área y departamento',
        input: {
          areaLabel: 'Seleccione área',
          departmentLabel: 'Seleccione departamento',
          catalogLabel: 'Seleccione',
          preventiveCatalogLabel:
            'Seleccione catálogo para solicitudes preventivas',
          correctiveCatalogLabel:
            'Seleccione catálogo para solicitudes correctivas',
        },
        snackbar: {
          config: {
            create: {
              success: 'Se ha creado con éxito la nueva configuración',
              error: 'Ocurrió un error al crear la configuración',
            },
            edit: {
              success: 'Se ha editado con éxito la configuración',
              error: 'Ocurrió un error al editar la configuración',
            },
          },
        },
      },
    },
  },
  serviceTime: {
    time: {
      main: {
        title: 'Niveles de servicios',
        table: {
          register: 'Identificación de registro',
          description: 'Descripción',
          area: 'Área',
          department: 'Departamento',
        },
        action: {
          title: '¿Está seguro que desea eliminar el servicio?',
        },
      },
      form: {
        titleCreate: 'Configuración de niveles de servicios',
        titleEdit: 'Configuración de niveles de servicios',
        generalDescription: 'Descripción general',
        classificationCriteria: 'Criterios de clasificación',
        slaResolution: 'Definición de tiempos de resolución SLA',
        olaResolution: 'Definición de tiempos de operación OLA',
        maximumTimeForAutomaticClosing: 'Tiempo máximo para cierre automatico',
        nextTime:
          'Los tickets que hagan match con los criterios definidos deben ser atendidos en el siguiente tiempo',
        ticketPriority: 'Personalizar tiempo por prioridad del ticket',
        firstAnswer: 'Tiempo primer respuesta',
        maxTime: 'Tiempo máximo de cierre automático',
        userInChargeManageRequests:
          'Quiero que el usuario encargado del departamento gestione las solicitudes (aprobar o rechazar)',
        input: {
          register: 'Identificación de registro',
          description: 'Descripción',
          area: 'Área',
          department: 'Departamento',
          service: 'Servicio',
          userRole: 'Rol de usuario',
          level: 'Nivel',
          closingTime: 'Seleccione el tiempo para el cierre',
        },
        snackbar: {
          create: {
            success:
              'La configuración de nivel de servicio se creó exitosamente',
            error:
              'Ocurrió un error al crear la configuración de nivel de servicio',
          },
          update: {
            success:
              'La configuración de nivel de servicio se actualizó exitosamente',
            error:
              'Ocurrió un error al actualizar la configuración de nivel de servicio',
          },
          delete: {
            success:
              'La configuración de nivel de servicio se eliminó exitosamente',
            error:
              'Ocurrió un error al eliminar la configuración de nivel de servicio',
          },
        },
      },
    },
  },
  activityTotal: 'Total de actividades',
  activitiesCompletedAndPending: 'Finalizadas / Total de actividades',
  forcingClosure: 'Cierre forzoso',
  forcingDescriptionOutRange:
    'Dado que estás fuera del rango permitido para finalizar esta actividad, debes iniciar el motivo por el cual la finalizas, aún cuando no estás en el área indicada.',
  forcingDescriptionIntoRange:
    'Para finalizar esta actividad debes indicar el motivo por el cual la finalizas.',
  showUser: 'Mostrar usuario',
  hiddenUser: 'Ocultar usuario',
  fullScreenOpen: 'Expandir actividades',
  fullScreenExit: 'Contraer actividades',
  storeSelect: 'Seleccionar unidad',
  closeComment: 'Comentario de cierre',
  storeCreate: 'Crear unidad',
  initDate: 'Fecha y hora de inicio',
  finishDate: 'Fecha y hora de fin',
  booth: 'Puesto',
  cancelActivity: 'Cancelar actividad',
  forcingCloseActivity: 'Cerrar actividad',
  cancelReasonLabel: 'Motivo de cancelación',
  cancelReason: 'Por favor indique el motivo de cancelación',
  addTruechecket: 'Marcar todos',
  addFalsechecket: 'Desmarcar todos',
  selectUsersToAssign: 'Seleccionar usuarios a asignar',
  usersToAssign: 'Usuarios a asignar',
  selectUserActivity:
    'Usuarios sin seleccionar, marca los usuarios para asignados a la actividad',
  store: 'Unidad',
  assigneds: 'Asignaciones',
  assigned: 'Asignar',
  tracking: 'En seguimiento',
  saveConfig: 'Guardar configuración',
  solveEvidences: 'Ver evidencias de solución',
  rejectEvidences: 'Ver evidencias de rechazo',
  approveEvidences: 'Ver evidencias de aprobación',
  solveEvidencesDownload: 'Evidencias de solución',
  rejectEvidencesDownload: 'Evidencias de rechazo',
  approveEvidencesDownload: 'Evidencias de aprobación',
  answer: 'Responder',
  resendReport: 'Reenviar informe',
  reassingProvider: 'Reasignar Proveedor',
  seeReport: 'Ver informe',
  report: 'Informe',
  resend: 'Reenviar',
  userAssigned: 'Usuarios asignados ({{users}})',
  userTracking: 'Usuarios dando seguimiento ({{users}})',
  listEvidence: {
    creator: 'Creador',
    solver: 'Solucionador',
    approved: 'Aprobación',
    reject: 'Rechazo',
  },
  activityDetail: 'Detalle de actividad',
  dateInitEnd: 'Fecha inicial y final',
  initialAndFinalProgramming: 'Programación inicial y final',
  managemetFolioEvidence: 'Evidencias requeridas para la gestión',
  creationEvidence: 'Evidencias requeridas para la creación',
  deleteSelected: 'Eliminar seleccionados',
  seeEvidence: 'Ver evidencias',
  description: 'Descripción: {{description}}',
  type: 'Tipo',
  title: 'Título: {{title}}',
  fieldRequired: 'El campo {{field}} es requerido',
  seeLastReportFolio: 'Ver último folio',
  seeLastActionPlan: 'Ver último plan de acción',
  save: 'Guardar',
  closeSession: 'Cerrar sesión',
  cancel: 'Cancelar',
  showFilters: 'Mostrar filtros',
  hideFilters: 'Ocultar filtros',
  addSection: 'Agregar sección',
  usersAssigned: 'Usuario(s) asignado(s)',
  supervisor: 'Supervisor(es)',
  newComment: 'Nuevo comentario',
  addComment: 'Agregar comentario',
  reSchedule: 'Reagendar',
  returnQuestionnaireConfig: 'Volver a configuración de cuestionario',
  pdf: 'Pdf',
  word: 'Word',
  csv: 'Excel',
  selectAll: 'Seleccionar todos',
  unselectAll: 'Deseleccionar todos',
  goToGeneralDetail: 'Ir al detalle general',
  version: 'Versión {{version}}',
  actionPlan: 'Plan de acción',
  evidence: 'Evidencias',
  defaultSetting: 'Usar la configuración por defecto',
  useSameConfig: 'Usar las mismas evidencias para el creador y el solucionador',
  reportFolio: 'Folio',
  incidence: 'Reincidencia',
  incidenceHistorie: 'Histórico de reincidencia',
  recurrenceAmmount: 'Cantidad de reincidencia: {{ammount}}',
  recurrenceAlert: 'Alerta de reincidencia',
  thereNoSupervisor: 'No hay supervisores',
  thereNoUsers: 'No hay usuarios',
  thereNotChange: 'No se han realizado cambios.',
  cancelActionPlan: 'Cancelar plan de acción',
  downloadEvidence: 'Descargar evidencias',
  downloadReport: 'Descargar reporte',
  observation: 'Observaciones',
  seeReport: 'Ver reporte',
  goActivity: 'Ir al detalle',
  textHelp: 'Texto de ayuda: {{textHelp}}',
  fromTo: 'Desde {{from}} hasta {{to}}',
  closeSchedule: 'Cancelar visita',
  closeScheduleUser: 'Cerrar agendamiento',
  sectionTo: 'Sección {{section}}/{{total}}',
  noSaveAnsGoAhead: 'Continuar sin guardar',
  add: 'Agregar',
  selectedUsers: 'usuarios seleccionados',
  deleteQuestionnaire: 'Borrar cuestionario',
  comment: 'Comentario',
  noInformation: 'No hay información',
  noInformationSome: 'No hay {key}',
  answeredQuestions: 'Preguntas resueltas',
  resolvedSections: 'Secciones resueltas',
  oldSections: 'Secciones',
  oldQuestions: 'Preguntas',
  reject: 'Rechazar',
  aprove: 'Aprobar',
  filterBy: 'Filtrar por',
  intervale: {
    intervale: 'Intervalo',
    '1w': 'semanal',
    '1d': 'diario',
    '1M': 'mensual',
  },
  commentMessage: {
    success: 'El comentario se creó exitosamente',
    error: 'Ocurrió un error al crear el comentario',
  },
  noActivities: 'No hay actividades asignadas',
  cancelComment: 'Cancelar comentario',
  editQuestinnaire: 'Editar cuestionario',
  permission: 'Permisología',
  goBackToConfig: '¿Quieres volver a la configuración anterior?',
  stayChanges: '¿Deseas conservar los cambios realizados?',
  saveAndFinished: 'Guardar y finalizar',
  saveDraft: 'Guardar borrador',
  structure: 'ESTRUCTURA',
  changeWillBeDiscarded: 'Los cambios previos serán descartados.',
  fieldsWillBeInclude: 'Campos a incluir',
  all: 'Todos',
  goToPermission: '¿Quieres ir a la vista de permisología?',
  lostConfig:
    'Se perderán las configuraciones realizadas que no se hayan guardado. ¿Deseas continuar?.',
  unexpectedError: 'Ocurrió un error inesperado',
  update: 'Actualizar',
  detail: 'Detalle',
  reassignUser: 'Reasignar usuario',
  sections: 'Secciones completadas',
  question: 'Preguntas completadas',
  result: 'Resultado',
  dateFromTo: 'Desde {start} al {end}',
  userUpdated: 'El usuario se actualizó correctamente',
  emailUpdated: 'El correo electrónico se actualizó correctamente',
  userUpdatedWithEmailError:
    'Se actualizó el usuario pero ocurrió un error al actualizar el correo',
  date: 'Fecha',
  edit: 'Editar',
  hour: 'Hora',
  hour_one: 'Hora',
  hour_other: 'Horas',
  reassign: 'Reasignar',
  reassignAreaAndDepartment: 'Reasignar área y dpto.',
  week: 'Semana',
  seeDetail: 'Ver detalle',
  forced: 'Forzoso',
  seeExecution: 'Ver ejecución',
  selectedArea: 'Área seleccionada',
  filter: 'Filtrar',
  filters: 'Filtros',
  cleanFilters: 'Limpiar filtros',
  successSearch: 'Búsqueda exitosa',
  deleteSelectedUsers: 'Eliminar usuarios seleccionados',
  wereFound: 'Se encontraron',
  ofUsers: 'usuarios. Para continuar debes agregar al menos un permiso',
  lastUpdate: 'Última actualización',
  wasCopied: 'Se copió el',
  waitAMoment: 'Espere un momento su solicitud se está procesando...',
  notFounds: 'No se encontraron :not_found:',
  notFound: 'No se encontró :not_found:',
  ninformationNotFound: 'No se encontró información',
  questions: {
    what: 'Qué',
    why: 'Por Qué',
    where: 'Dónde',
    who: 'Quién',
    when: 'Cuándo',
    how: 'Cómo',
    howMuch: 'Cuánto',
    observation: 'Observaciones',
    area: 'Área',
    state: 'Departamento',
    department: 'Departamento',
    customerSatisfactionQuestion: 'Pregunta de satisfacción al cliente',
  },
  validate: {
    template: {
      theField: 'El campo',
      theFields: 'Los campos',
      theField2: 'El campo',
      theField3: 'Los campos',
      isRequired: 'es requerido',
      areRequired: 'son requeridos',
      isRequired2: 'es requerido',
      areRequired2: 'son requeridos',
    },
    required: {
      companyId: 'La compañía es requerida',
      questionnaireName: 'El nombre del cuestionario es requerido',
      type: 'El campo tipo es requerido',
      answer: 'El campo respuesta es requerido',
      templateName: 'El campo título es requerido',
      amounts: 'El campo cantidad máxima es requerida',
      amount: 'El campo cantidad máxima es requerida',
      sizes: 'El campo caracteres máximo es requerido',
      firstNames: 'El campo nombres es requerido',
      lastNames: 'El campo apellidos es requerido',
      cities: 'El campo ciudades es requerido',
    },
  },
  formats: {
    png: 'PNG',
    jpg: 'JPG',
    jpeg: 'JPEG',
    mp4: 'MP4',
    wmv: 'WMV',
    wma: 'WMA',
    pdf: 'PDF',
    doc: 'DOC',
    docx: 'DOCX',
    xls: 'XLS',
    xlsx: 'XLSX',
    ppt: 'PPT',
    pptx: 'PPTX',
    txt: 'TXT',
    csv: 'CSV',
  },
  amount: {
    maxSize: 'Tamaño Max.',
    maxLong: 'Long. Max.',
    maxAmount: 'Cant. Max.',
    comment: 'Caracteres Max.',
  },
  priority: {
    suggestion: 'Baja',
    medium: 'Media',
    urgent: 'Urgente',
    high: 'Alta'
  },
  dataNotFound: 'Debes agregar un rango de búsqueda para obtener resultados',
  userInTheSearch: 'usuarios con respecto a los filtros agregados.',
  userFilterWarningTitle:
    '¿Estás seguro que quieres aplicar los siguientes filtros?',
  userFilterWarningDescription:
    'Si aplicas los filtros, se perderán los cambios realizados',
  toAddPermissions: 'Para continuar debes agregar al menos un permiso',
  toAddUsers: 'Para continuar debes seleccionar al menos un usuario',
  enableQuest: '¿Habilitar encuesta de satisfacción al cliente?',
  answers: 'Respuestas',
  atention: 'Atención',
  uploadEvidences: 'Cargar evidencias',
  detailEvidences: 'Ver evidencias',
  errorRegisters: 'Registro de errores',
  confirmation: 'Confirmación',
  noData: 'N/A',
  required: 'Obligatorio',
  goBackToTheList: 'Regresar al listado',
  search: 'Buscar',
  appliedScheduled: 'Agenda aplicada',
  load: 'Cargar',
  destinity: 'Unidad / Destino',
  assignedBy: 'Asignador',
  importData: 'Importar data',
  loadScheduled: 'Carga de agenda',
  loadMassiveScheduled: 'Importación masiva de agenda',
  fileWithError: 'No se pudieron subir todos los archivos',
  fileEmptyError: 'El archivo está vacío o faltan campos por llenar',
  invalidateTemplate:
    'El archivo adjunto no corresponde a la plantilla o está vacío',
  invalidateFile:
    'Existen registros que no son correctos. Verifica la información en el archivo descargado.',
  successBatch: 'La carga del archivo se realizó exitosamente',
  noReport: 'No se encontró reporte',
  reportError: 'Ocurrió un error al enviar el reporte',
  reportSuccess: 'El reporte se envió exitosamente',
  noBacklog: 'No tiene atraso',
  notDataTable: 'No se encuentran datos para descargar',
  startDate: 'Fecha de inicio',
  initialProgramming: 'Programación inicial',
  endDate2: 'Fecha de fin',
  finalProgramming: 'Programación final',
  cancelActivity: 'Cancelar actividad',
  forceClosure: 'Cierre forzoso',
  activityClose: 'Cierre de actividad',
  invalidateDate: 'El formato de la fecha no es válido',
  wrongDate: 'El rango de la fecha no es válido',
  download: 'Descargar',
  scheduledTime: 'Tiempo de ejecución',
  exit: '¿Estás seguro que quieres regresar?',
  lostChange: 'Al regresar se perderán los cambios realizados',
  selected: 'Seleccione',
  endDate: 'Fecha de finalización',
  reportDate: 'Fecha de reporte',
  notHistory: 'No se encontró historial',
  doYouWantDoing: '¿Qué deseas hacer?',
  notInfo: 'No se encontró detalle',
  noStores: 'No se encontraron unidades',
  noQuestionnaires: 'No se encontraron cuestionarios',
  notVisits: 'No se encontraron visitas',
  closeComment: 'Comentario de cierre',
  assignedUsers: 'Usuarios asignados',
  assignedUser: 'Usuario asignado',
  directSuperior: 'Jefe directo',
  directSuperiors: 'Jefe(s) directo(s)',
  createdByUser: 'Usuario planificador',
  next: 'Siguiente',
  yes: 'Si',
  saveChanges: 'Guardar cambios',
  folioConfig: 'Configuración de gestión de folio',
  returnActivityDetail: 'Volver al detalle de la actividad',
  returnreportFolioConfig: 'Volver a la configuración general de folio',
  no: 'No',
  delete: 'Eliminar',
  wasAdded: 'Se agregó',
  wereAdded: 'Se agregaron',
  close: 'Cerrar',
  doYouWantGoBackToAccessList: '¿Desea regresar a la tabla de accesos?',
  continue: 'Continuar',
  submit: 'Enviar',
  noOptions: 'No hay opciones',
  saveConfigurations: 'Guardar configuración',
  confirm: 'Confirmar',
  accept: 'Aceptar',
  return: 'Regresar',
  quizQuestion: 'Pregunta del cuestionario',
  byItem: 'Por ítem',
  byQuest: 'Por cuestionario',
  points: 'puntos',
  asks: 'Preguntas',
  ask: 'Pregunta',
  loadUsers: 'Cargar usuarios',
  searchUsers: 'Buscar usuarios',
  addUsers: 'Agregar usuarios',
  mts: 'Metros',
  assignedSupervisor: 'Supervisores asignados',
  assignedAgent: 'Agente asignado',
  scheduleDate: 'Fecha de la visita',
  createNew: ' ¿Desea crear uno nuevo?',
  crud: {
    edit: 'Editar',
    delete: 'Eliminar',
  },
  connectives: {
    by: 'por',
  },
  evidences: {
    image: 'Imagen desde galería',
    video: 'Video',
    sign: 'Firma',
    comment: 'Comentario',
    camera: 'Cámara',
    video_gallery: 'Video desde galería',
    file: 'Documento',
    1: 'Imagen',
    2: 'Videos',
    3: 'Firma',
    4: 'Documento',
    5: 'Comentario',
    6: 'Cámara',
    7: 'Video desde galería',
  },
  messages: {
    errors: {
      noUsers: 'No se encontraron usuarios',
      usersNeedAtLeastOnePermissopn:
        'Los usuarios necesitan al menos un permiso',
      thereAreUsersWithoutPermissionsTitle:
        '¿Está seguro de que quiere guardar este cuestionario?',
      thereAreUsersWithoutPermissionsDescription:
        'La configuración de los permisos no está completada',
      allUsersExisted:
        'Los usuarios seleccionados ya se encuentran en el listado de accesos.',
      userNotHavePermissionToLogIn:
        'El usuario ingresado no cuenta con los permisos necesarios',
      logError: 'Usuario o contraseña incorrecta',
      emailError: 'Ocurrió un error al actualizar el correo electrónico',
      userError: 'Ocurrió un error al actualizar el usuario',
      consultCode: 'Ocurrió un error al enviar el correo, intente de nuevo',
      validateCode: 'Ocurrió un error al validar el código, intente de nuevo',
      invalidateCode:
        'El código ingresado no es válido, solicite un nuevo código',
      ERR_ACTIVITY_FINISHED: "No es posible reagendar esta actividad porque ya ha sido completada.",
      ERR_DATE_OUT_LESSER : "El rango de fechas seleccionado debe ser posterior a la fecha actual.",
      ERR_DATE_OUT_RANGE : "La fecha de inicio debe ser anterior a la fecha de finalización.",
      ERR_SCHEDULE_VISIT: "El usuario asignado no tiene permisos de cuestionario",
      ERR_ALREADY_EXISTS:
        'El correo electrónico o número de teléfono ya está en uso',
      ERR_ACTION_PLAN_APPROVERS_NOT_FOUND: 'No hay aprobadores asociados.',
      ERR_USERNAME_EXIST: 'El correo electrónico ya está en uso',
      ERR_AUTH: 'No tienes los permisos necesarios para realizar esta acción.',
      ERR_EMAIL: 'El correo electrónico no es válido',
      ERR_ALREADY_ANSWERING:
        'El folio ya fue solucionado anteriormente y fue asignado al usuario',
      ERR_ALREADY_ANSWERED: 'Ya fue respondido',
      ERR_BAD_REQUEST_MONTH:
        'El intervalo de fechas es inferior a un mes, la frecuencia no puede ser mensual',
      ERR_BAD_REQUEST_WEEKLY:
        'El intervalo de fechas debe tener al menos una semana hábil para permitir generar un agendamiento semanal.',
      ERR_BAD_REQUEST_CYCLICAL:
        'El intervalo de fechas es menor a un día hábil o no es válido para un agendamiento cíclico.',
      ERR_BAD_REQUEST_DAILY:
        'El intervalo de fechas debe tener al menos un día hábil para permitir generar un agendamiento diario.',
      ERR_SCHEDULE_OUT_RANGE:
        'No se puede crear el agendamiento porque el rango de la serie es menor a la duración.',
      ERR_NOT_USER_MANAGES:
        'No se encontraron supervisores disponibles para asociar al usuario en la visita programada.',
      ERR_NOT_USER_ASSINGS: 'El supervisor no tiene agentes asociados',
      ERR_CANNOT_CREATE_VISITS: 'La visita no pudo ser asignada',
      ERR_OPTION_GROUP_IN_USE: 'El grupo de opciones ya esta siendo utilizado',
      ERR_NOT_FINALIZED: 'La visita agendada aun no está finalizada',
      ERR_NO_ACTIVE_USER: 'La cuenta no se encuentra activa',
      VALIDATION_ERROR: 'Hay campos que faltan por completar',
      '01': 'El folio ya existe',
      '02': 'El folio no pudo ser creado porque no tiene una configuración',
            "ERR_LIMIT_EXCEEDED" : "El folio no pudo ser creado porque se ha alcanzado el límite permitido",
      ERR_VISIT_NOT_CREATED:
        'El folio no pudo ser creado porque la visita no ha sido creada',
      ERR_USER_NOT_ALLOWED_REASSIGN:
        'El usuario no tiene los permisos necesarios para reasignar folios',
      ERR_VALIDATION_CODE: 'El código que ingresó no es válido',
      ACC_NO_REQUIRE_VALIDATE: 'La cuenta ya está validada',
      EVIDENCE_NOT_FOUND: 'Algunos de los archivos no se guardaron',
      ERR_SOME_QUESTIONNAIRE_IS_STARTED:
        'Alguno de los cuestionarios agendados se inició',
      ERR_USER_WITHOUT_PERMISSIONS:
        'El usuario no tiene los permisos necesarios',
      department:
        'No se puede eliminar el departamento, porque se encuentra asociado a un cuestionario principal',
      REQUIRE_VALIDATE:
        'La cuenta no está validada, se enviará un código a su correo electrónico',
      REQUIRE_CHANGE_PASS:
        'Necesitas cambiar tu contraseña, te enviaremos a la página correspondiente',
      errBadRequestDailyErrBadRequestDaily:
        'El intervalo de fechas es superior a una semana, no puede ser diario',
      errBadRequestWeeklyErrBadRequestWeekly:
        'El intervalo de fechas es inferior a una semana, no puede ser semanal',
      errBadRequestMonthErrBadRequestMonth:
        'El intervalo de fechas es inferior a un mes, la frecuencia no puede ser mensual',
      INVALID_USERNAME_TYPE: 'El correo electrónico no es válido',
      VALIDATED_ACCOUNT:
        'La cuenta se confirmó exitosamente, se enviará un código a su correo electrónico para el cambio de contraseña',
      VALIDATED_ACCOUNT_PASSWORD:
        'La cuenta se confirmó exitosamente, para finalizar, debes actualizar tu contraseña',
      ERR_NOT_ANSWERED: 'El folio no tiene respuesta',
      ERR_CANNOT_CANCELLED_ACTION_PLAN:
        'El plan de acción ya fue respondido por la tienda.',
      ERR_REPORT_FOLIO_REJECTED: 'El folio ya está rechazado o aprobado',
      ERR_VALIDATION_FILES: 'Alguno de los archivos no es válido',
      ERR_NOT_FOUND: 'No se encontró la información',
      ERR_NO_PERMISSIONS: 'El usuario no cuenta con los permisos necesarios para realizar esta acción.',
      ERR_NOT_ALLOWED_DELETE_FILE: 'El usuario no tiene permiso para eliminar este archivo',
      ERR_NOT_FOUND_FILE : "No se encontró ningún archivo con ese ID.",
      ERR_NOT_ALLOWED_UPDATE_FILE : "No tienes permisos para editar este archivo.",
      ERR_VALID_DATE_START:
        'La fecha de inicio debe ser mayor o igual a la fecha actual',
      ERR_USER_QUESTIONNAIRE_NOT_TO_BE_STARTED:
        'La visita ya no se puede cerrar',
      ERR_NOT_ALLOWED: 'El folio no se puede actualizar',
      ERR_UNAUTHORIZED: 'El usuario no cuenta con los permisos necesarios',
      ERR_ALREADY_SCHEDULED:
        'El usuario ya cuenta con este cuestionario agendado',
      ERR_REASSIGNED_REPORT_FOLIO: 'Ocurrió un error al reasignar el usuario',
      visits: {
        create: {
          '02': 'No se han podido crear las visitas debido a posibles problemas',
          '01': 'Algunas visitas no fueron creadas, debido a que los siguientes usuarios tienen posibles problemas:',
        },
      },
    },
    sureWantDeleteTheUser:
      '¿Está seguro que desea eliminar los usuarios seleccionados?',
    loseThePermissions:
      'Al eliminar los usuarios, se les removerá la configuración de permisos asignada',
    areYouSure: '¿Está seguro que desea',
    thisUser: 'este usuario?',
    emptyTable: 'Sin contenido',
    sendEmail: 'Enviar copia por correo electrónico',
    limitFolios: 'Limitar cantidad de folios',
    questionnaire: 'un cuestionario?',
    store: 'una unidad?',
    status: {
      DELETE: 'eliminar',
      1: 'activar',
      2: 'inactivar',
      11: 'retirar',
      14: 'bloquear',
    },
    description: {
      DELETE:
        'Al eliminar un usuario, se borrará de tu lista y debes realizar nuevamente el registro',
      1: '',
      2: '',
      11: '',
      14: 'Un usuario bloqueado no podrá acceder a la plataforma desde ningún dispositivo',
    },
  },
  exampleEmail: 'test@email.com,test2@email.com',
  validations: {
    required: 'El campo es requerido',
    obligatory: 'Obligatorio',
    wrongPassword:
      'La contraseña debe contener al menos 1 mayúscula 1 minúscula y 1 número',
    wrongPhoneNumber: 'El número de teléfono no es válido',
    alphaNumeric: 'El campo tiene caracteres no permitidos',
    decimal: 'El formato de decimales esta mal',
    itIsNotNumber: 'El campo solo acepta números',
    coordinate: 'El formato de coordenadas no es válido',
    existedCurp: 'El curp ya está registrado',
    confirmPassword: 'Las contraseñas no coinciden',
    wrongEmail:
      'Debe ingresar un correo electrónico válido ejemplo: email@email.com',
    min: 'El campo debe contener mínimo',
    max: 'El campo debe contener máximo',
    minRejects: 'La cantidad mínima de rechazos es 1',
    minFolios: 'La cantidad mínima de folios es 1',
    hasContained: 'El campo debe contener',
    character: 'caracteres',
    startDate: 'La fecha no es válida',
    minimus0minute:
      'La fecha de inicio debe ser mayor o igual a la fecha actual',
    minimusCurrentDay: 'La fecha de fin debe ser mayor a la fecha actual',
    maximum24Hours: 'La duración no puede exceder el limite al permitido de 24 horas.',
    minimus5minute:
      'La fecha de fin debe ser al menos 5 minutos mayor a la fecha de inicio',
    minimusCurrentDayStart:
      'La fecha de inicio debe ser mayor o igual a la fecha actual',
    minimusOneDayToDuration: 
      'La duración debe ser de minimo un día',
    minimus1Day:
      'La fecha de fin debe ser al menos 1 día mayor a la fecha de inicio',
    isUnderTheDatesRange: 
      'La duración excede el número de días hábiles dentro del rango de fechas establecido.',
    daysArentValid:
      'No se encontraron días hábiles dentro del rango de fechas establecido.',
    minimus7Day:
      'La fecha de fin debe ser al menos 1 semana mayor a la fecha de inicio',
    maximus7Day:
      'La duración no puede superar los 7 días',
    afterEndDate:
      'La fecha inicio de ejecución debe ser al menos 5 minutos menor a la fecha fin de mantenimiento',
    beforeStartDate:
      'La fecha inicio de ejecución debe ser mayor a la fecha inicio de mantenimiento',
    afterEndDateQuestionarie:
      'La fecha fin de ejecución debe ser mayor a la fecha inicio de mantenimiento',
    beforeStartDateQuestionarie:
      'La fecha fin de ejecución debe ser menor a la fecha fin de mantenimiento',
    wrongFile: 'El archivo no es válido',
    selectACheck: 'Debe seleccionar al menos un tipo de formato',
    satisfationQuestionIsRequired:
      'La pregunta de satisfacción al cliente es requerida',
  },
  toggle: {
    byItem: 'Por ítem',
    byQuest: 'Por cuestionario',
  },
  permission_check: {
    access: 'Aplica',
    report: 'Informe',
    emailNotification: 'Email',
    result: 'Resultados',
    execution: 'Ejecución',
    disable: 'Deshabilitar',
  },
  tags: {
    seeFile: 'Ver archivo',
    fileType: 'Tipo de archivo',
    downloadFile: 'Descargar archivo',
    selectStartHour: 'SELECCIÓN DE HORA DE INICIO',
    selectEndHour: 'SELECCIÓN DE HORA DE FIN',
    selectStartDate: 'SELECCIÓN DE FECHA DE INICIO',
    selectEndDate: 'SELECCIÓN DE FECHA DE FIN',
    timezone: 'Zona horaria',
    each: 'Cada',
    createUnityUser: 'Crear usuario de la unidad',
    editUnityUser: 'Actualizar usuario de la unidad',
    folioType: 'Tipo de folio',
    provider: 'Proveedor',
    register: 'registro',
    preventiveCatalog: 'Catálogo para solicitudes preventivas',
    correctiveCatalog: 'Catálogo para solicitudes correctivas',
    activityType: 'Tipo de actividad',
    activityName: 'Nombre de la actividad',
    activities: 'Actividades',
    requireComment: 'El comentario de observación es obligatorio',
    delete: 'Eliminar',
    disable: 'Deshabilitar',
    serachByNameAndCurp: 'Buscar por nombre o CURP',
    searchByTitle: 'Buscar por título',
    version: 'Versión',
    storeRef: 'Unidad referenciada',
    programmed: 'Ver agendamientos programados',
    type: 'Tipo',
    open_scheduled: 'Ver agendamientos libres',
    reason: 'observación del folio',
    motive: 'Motivo',
    reassignUser: 'Reasignar Usuario',
    priority: 'Prioridad',
    questionOption: 'Opciones de preguntas',
    answer: 'respuesta',
    percentage: 'Rango de resultados',
    maxReject: 'Cantidad',
    maxSize: 'Tamaño Max.',
    maxAmount: 'Cant. Max.',
    maxCharacters: 'Caracteres Max.',
    intervale: 'Intervalo',
    storeId: 'Unidad - ID',
    closeStore: 'Unidad de cierre / Destino',
    closeStoreAndId: 'Unidad de cierre - Id',
    idStore: 'ID - Unidad',
    storeInformation: 'Información de la unidad',
    userInformation: 'Información del usuario',
    questionnairesInformation: 'Información de los cuestionarios',
    questionnaireInformation: 'Información del cuestionario',
    filterByCurrentWeek: 'Ver semana activa',
    filterByUser: 'Filtrar usuarios',
    sectionName: 'nombre de la sección',
    questionText: 'texto de la pregunta',
    answerText: 'texto de la respuesta',
    password: 'Contraseña',
    emailEdition: 'Edición de email',
    passwordEdition: 'Edición de contraseña',
    report: 'Reporte',
    folio: 'Folio',
    noLimits: 'Sin límite',
    limitFolios: 'Cant. Max.',
    childZone: 'Clase',
    value: 'Valor',
    ampm: 'AM/PM',
    sections: 'Selecciones',
    questionnaireStatus: 'Estatus del cuestionario',
    updateDate: 'Fecha de actualización',
    updateHour: 'Hora de actualización',
    openingTime: 'Hora apertura',
    closingTime: 'Hora cierre',
    duration: 'Duración',
    initDate: 'Fecha inicio',
    initHour: 'Hora inicio',
    endDate: 'Fecha fin',
    endHour: 'Hora fin',
    requestDate: 'Fecha de solicitud',
    requestHour: 'Hora de solicitud',
    deadlineDate: 'Fecha de plazo',
    deadlineHour: 'Hora de plazo',
    answers: 'Respuestas',
    soloveDate: 'Fecha de solución',
    soloveHour: 'Hora de solución',
    elapsedDays: 'Días transcurridos',
    elapsedHour: 'Horas transcurridas',
    executionDay: 'Día de ejecución',
    rejects: 'Rechazos',
    year: 'Año',
    month: 'Mes',
    weekYear: 'Semana',
    permission: 'Permisos',
    gerent: 'Gerente',
    id: 'ID',
    fatherZone: 'Zona padre',
    class: 'Clase',
    activate: 'Activar',
    desactivate: 'Desactivar',
    visitStatus: 'Estatus de la visita',
    result: 'Resultado obtenido',
    unit: 'Unidades',
    unitStore: 'Unidad',
    idUnit: 'ID Unidad',
    country: 'País',
    zone_gerent: 'Gerente de zona',
    checklist: 'Checklist',
    visit_date: 'Fecha de visita',
    start_hour: 'Hora de visita',
    color0: 'Color Primario',
    color1: 'Color Secundario',
    color2: 'Color ERROR',
    color3: 'Color Subtítulos',
    color4: 'Color Párrafos',
    color5: 'Color Header móvil',
    color6: 'Color 1',
    color7: 'Color del degradado',
    color8: 'Color 3',
    zoneInitId: 'Zona padre',
    item: 'Ítem',
    dateRequestion: 'Fecha de solicitud',
    deadline: 'Plazo',
    backlog: 'Atraso',
    userName: 'Nombre de usuario',
    cveDivision: 'CVE',
    maxRejections: 'Máximo número de rechazos',
    optionNumber: '# de Opciones',
    quantity: 'Cantidad',
    optionGroupTitle: 'Título del grupo de opciones',
    quest_name: 'Nombre del cuestionario',
    quest_score: 'Score',
    createTime: 'Fecha de creación',
    updateTime: 'Fecha de actualización',
    hourTime: 'Hora de creación',
    questionnaires: 'Cuestionarios',
    store: 'Unidad',
    stores: 'Unidades',
    agent: 'Agente',
    agents: 'Agentes',
    assignedUnit: 'Unidades asignadas',
    assignedAgents: 'Agentes asignados',
    available_from: 'Disponible desde',
    available_to: 'Disponible hasta',
    application_date: 'Fecha de aplicación',
    ask: '# Preguntas',
    question: 'Pregunta',
    file: 'Icono',
    admin: 'Administradores',
    file2: 'Adjuntar archivo',
    loadCsv: 'Cargar archivo XLSX',
    action_plan: 'Plan de acción',
    action: 'Acciones',
    app: '# de aplicaciones',
    user: 'Usuario',
    users: 'Usuarios',
    name: 'Nombre',
    staffName: 'Nombre del gerente',
    store_name: 'Nombre de la unidad',
    createUnityUser: 'Crear usuario de la unidad',
    editUnityUser: 'Actualizar usuario de la unidad',
    storeList: 'Listado de unidades',
    agentList: 'Listado de usuarios',
    divisions: 'Divisiones',
    division: 'División',
    correctAnswer: 'Respuestas correctas',
    incorrectAnswer: 'Respuestas negativas',
    zones: 'Zonas',
    questionnaire: 'Cuestionario',
    section: 'Sección',
    minamount: 'cant. min.',
    minAmount: 'cant. min.',
    address: 'Dirección',
    latitude: 'Latitud',
    longitude: 'Longitud',
    storeName: 'Unidad',
    unityName: 'Destino',
    score: 'Score de la unidad',
    userManageId: 'Gerente de la unidad',
    userManage: 'Gerente de la unidad',
    manager: 'Gerente',
    company: 'Compañía',
    companies: 'Compañías',
    company_name: 'Nombre de compañías',
    companyName: 'Nombre de compañías',
    zip_code: 'Zip Code',
    zipCodeCp: 'Zip Code',
    sectionpoints: 'puntos de la sección',
    sectionPoints: 'puntos de la sección',
    keyCode: 'ID',
    zone: 'Zona',
    zoneClass: 'Zona - Clase',
    city: 'Ciudad',
    cities: 'Ciudades',
    supervisor: 'Supervisor',
    assignedUser: 'Usuario asignado',
    frequency: 'Frecuencia',
    state: 'Departamento',
    states: 'Departamentos',
    companyId: 'Compañía',
    zipCodeId: 'Zip Code',
    zipCode: 'Zip Code',
    firstName: 'Nombre',
    lastName: 'Apellido',
    fullname: 'Nombres y apellidos',
    roleId: 'Rol',
    role: 'Rol',
    roles: 'Roles',
    status: 'Estatus',
    priority: 'Prioridad',
    stateCategory: 'Estado',
    nameAndLastName: 'Nombre y apellido',
    instructions: 'Instrucciones',
    curp: 'CURP',
    requestionUser: 'Usuario solicitante',
    gender: 'Género',
    phone: 'Teléfono',
    phoneNumber: 'Número telefónico',
    email: 'Correo electrónico',
    email2: 'Correo',
    userRol: 'Rol de usuario',
    startDate: 'Fecha de creación',
    title: 'Título',
    description: 'Descripción',
    userType: 'Tipo de usuario',
    userTypeLabel: 'Tipo de usuario',
    answerType: 'Tipo de respuesta',
    picture: 'Fotografía',
    videos: 'Videos',
    accountHistory: 'Historial de cuenta',
    fieldRequireds: 'Campos requeridos',
    fields: 'Preguntas generales',
    from: 'Desde',
    to: 'Hasta',
    totalPoints: 'Puntos totales',
    dateLastApp: 'Fecha de la última aplicación',
    actionPlanCount: '# de planes de acción',
    foliosCount: '# de folios',
    actionPlan: 'Planes de acción',
    actionPlanType: 'Tipo de plan de acción',
    area: 'Área',
    areas: 'Áreas',
    number: 'Número',
    department: 'Departamento',
    departments: 'Departamentos',
    usersByHierarchy: 'Usuarios de mi jerarquía',
    catalog: 'Catálogo',
    responsible: 'Responsable',
    folios: 'Folios',
    webAccess: 'Acceso web',
    mobileAccess: 'Acceso móvil',
  },
  status: {
    expiredFolio: 'Vencido',
    expidred_without_solution: 'Vencido sin solución',
    active: 'Activo',
    inactive: 'Inactivo',
    pause: 'Pausado',
    close: 'Cerrado',
    cancel: 'Cancelado',
    reagended: 'Reagendado',
    reassigned: 'Reasignado',
    finished: 'Completado',
    toBeStatarted: 'Por iniciar',
    notFinished: 'No finalizado',
    withDraw: 'Retirado',
    waiting: 'En espera',
    reject: 'Rechazado',
    blocked: 'Bloqueado',
    created: 'Creado',
    UPDATE: 'Actualizado',
    started: 'Iniciado',
    responded: 'En espera de aprobación',
    aproved: 'Aprobado',
    await_solution: 'En espera de solución',
    expired: 'Vencido',
    incomplete: 'No completado',
    draft: 'Borrador',
    pending: 'Pendiente',
    deleted: 'Eliminado',
  },
  femaleStatus: {
    active: 'Activa',
    inactive: 'Inactiva',
    pause: 'Pausada',
    close: 'Cerrada',
    cancel: 'Cancelada',
    reagended: 'Reagendada',
    reassigned: 'Reasignada',
    finished: 'Completada',
    toBeStatarted: 'Por iniciar',
    notFinished: 'No finalizada',
    withDraw: 'Retirada',
    witing: 'En espera',
    reject: 'rechazada',
    blocked: 'Bloqueada',
    created: 'Creada',
    UPDATE: 'Actualizada',
    started: 'Iniciada',
    responded: 'Recibida',
    aproved: 'aprobada',
    await_solution: 'Espera Solución',
    expired: 'Vencida',
    incomplete: 'No completada',
    draft: 'En borrador',
  },
  menuList: {
    activateUser: 'Reactivar usuario',
    inactivateUser: 'Desactivar usuario',
  },
  fields: {
    gender: {
      1: 'Femenino',
      2: 'Masculino',
      3: 'Otro',
    },
  },
  brandCustomization: {
    selectBelowTheColorsWithWhichTheInterfacesOfYourEnvironment:
      'Seleccione a continuación los colores con los que se visualizarán las interfaces de su ambiente de CheckPlus',
    appPersonalization: 'Personalización de la marca',
    restoreDefaultSettings: 'Restablecer configuración por defecto',
    mobileGradients: 'Gradientes de móvil',
    containsAColorCombinationCalledGradient:
      'Contiene una combinación de colores denominada "Gradiente", la cual hace referencia a una mezcla gradual de colores seleccionados',
    theFirstAndThirdTonesOfTheGradientAreDeterminedFromThePrimaryAndSecondaryColors:
      'El primer y tercer tono del degradado se determinan a partir de los colores primario y secundario, respectivamente.',
    colorsSpecificallyUsedForTheBackgroundAndHeaderOfTheMobileApplication:
      'Colores específicamente utilizados para el fondo y el Header o cabecera de la aplicación móvil.',
    attachaJSONFileForTheConfigurationOfAllTheTextOfTheApplication:
      'Adjunta un archivo JSON para la configuración de todo el texto de la aplicación (Títulos, subtítulos, párrafos, notificaciones y otros)',
    setTheAppPermissionsForLocation:
      'Configura a continuación los permisos de la aplicación en cuanto a la localización o ubicación',
    makeTheNecessaryAdjustmentsRegardingImagesThatWillBeDisplayedInTheApplication:
      'Realiza los ajustes necesarios en cuanto a imágenes que se visualizarán en la aplicación de CheckPlus',
  },
}
